export const REDIRECT_URL_QUERY_PARAM = 'redirectUrlPreview';

export const CONTEXT_QUERY_PARAM = 'context';
export const IMPORT_CONTEXT = 'import';
